export default __webpack_public_path__ + "static/media/radio-button-checked.8dd47356.svg";